import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "dialog-footer-btn-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.dialogFooterCss)
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createCommentVNode(" btnConfig 설정 O "),
            (!!_ctx.btnConfig)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.btnConfig, ({ text, cssClass }, index) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                        key: index,
                        class: _normalizeClass(`brg-btn size-xl ${cssClass}`),
                        onClick: () => { index === 0 ? _ctx.handleCancel() : _ctx.handleOk(); }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.' + text)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "onClick"]));
                }), 128 /* KEYED_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" btnConfig 설정 X "),
                    _createCommentVNode(" 취소 버튼 "),
                    (_ctx.cancel)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            flat: "",
                            class: _normalizeClass(_ctx.cancelCss),
                            onClick: _ctx.handleCancel
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "cancel", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')) + " ", 1 /* TEXT */),
                                    (_ctx.showShortcut)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" (" + _toDisplayString(_ctx.toChar(_ctx.shortcut.cancel)) + ") ", 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["class", "onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 변경 버튼 "),
                    (_ctx.change)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            flat: "",
                            class: _normalizeClass(_ctx.changeCss),
                            onClick: _ctx.handleChange
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "change", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.change')), 1 /* TEXT */)
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["class", "onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 확인 버튼 "),
                    (_ctx.ok)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            flat: "",
                            class: _normalizeClass(["cy-confirm-ok", _ctx.okCss]),
                            onClick: _ctx.handleOk
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "ok", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.ok')) + " ", 1 /* TEXT */),
                                    (_ctx.showShortcut)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" (" + _toDisplayString(_ctx.toChar(_ctx.shortcut.enter)) + ") ", 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["class", "onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 삭제 버튼 "),
                    (_ctx.remove)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 3,
                            flat: "",
                            class: _normalizeClass(_ctx.removeCss),
                            onClick: _ctx.handleRemove
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "remove", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.remove')), 1 /* TEXT */)
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["class", "onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 확인 단일 버튼 "),
                    (_ctx.okOnly)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 4,
                            flat: "",
                            class: _normalizeClass(_ctx.okOnlyCss),
                            onClick: _ctx.handleOk
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "ok-only", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.ok')), 1 /* TEXT */)
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["class", "onClick"]))
                        : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
        ])
    ], 2 /* CLASS */));
}
